var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      _vm._l(_vm.visits.data, function(item, index) {
        return _c(
          "div",
          { key: "register-visit" + index },
          [
            _c(
              "validation-observer",
              {
                ref: "registerVisitForm",
                refInFor: true,
                attrs: { novalidate: "", tag: "form" }
              },
              [
                index != _vm.visits.data.length - 1 ||
                (index == _vm.visits.data.length - 1 && !_vm.isReadOnly)
                  ? _c(
                      "custom-callout",
                      {
                        staticClass: "mb-3 custom-callout",
                        attrs: { controlled: true, opened: item.isOpen },
                        on: {
                          "click:open": function($event) {
                            return _vm.onToggleAdditionalInfo(item, index)
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            item.selectedType
                              ? {
                                  key: "edition",
                                  fn: function() {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "bg-secondary-9 p-2" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "info-panel bg-white rounded pb-3"
                                            },
                                            [
                                              _c(
                                                "b-tabs",
                                                {
                                                  attrs: {
                                                    "active-nav-item-class":
                                                      "mipe-tab font-weight-bold text-green active-nav-item-custom",
                                                    "active-tab-class": "",
                                                    "content-class": "mt-3",
                                                    "nav-class":
                                                      "custom-nav-container",
                                                    "no-nav-style": true
                                                  }
                                                },
                                                [
                                                  _vm.hideVisitAdditionalInformation(
                                                    item.selectedType
                                                  )
                                                    ? _c(
                                                        "b-tab",
                                                        {
                                                          attrs: {
                                                            active:
                                                              item.selectedTab ==
                                                              _vm
                                                                .additionalInfoTabs
                                                                .VISIT_ADDITIONAL_INFO,
                                                            title:
                                                              "Información Adicional de Visita"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row mx-4"
                                                            },
                                                            [
                                                              _vm.enableRepositionDate(
                                                                item.selectedType
                                                              )
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "color-secondary-6"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " Fecha a Reponer: "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "validation-provider",
                                                                        {
                                                                          attrs: {
                                                                            rules:
                                                                              "required"
                                                                          },
                                                                          scopedSlots: _vm._u(
                                                                            [
                                                                              {
                                                                                key:
                                                                                  "default",
                                                                                fn: function({
                                                                                  errors
                                                                                }) {
                                                                                  return [
                                                                                    _c(
                                                                                      "custom-drop-down",
                                                                                      {
                                                                                        attrs: {
                                                                                          disabled:
                                                                                            item.saved ||
                                                                                            !_vm.canEditReposition,
                                                                                          error:
                                                                                            errors[0],
                                                                                          fieldkey:
                                                                                            "id",
                                                                                          fieldname:
                                                                                            "name",
                                                                                          options:
                                                                                            _vm.repositions,
                                                                                          placeholder:
                                                                                            "Seleccione"
                                                                                        },
                                                                                        model: {
                                                                                          value:
                                                                                            item.selectedVisitInfoDateReposition,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              item,
                                                                                              "selectedVisitInfoDateReposition",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "item.selectedVisitInfoDateReposition"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                }
                                                                              }
                                                                            ],
                                                                            null,
                                                                            true
                                                                          )
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                              _vm.enableJustification(
                                                                item.selectedType
                                                              )
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "color-secondary-6"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " Justificación: "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "validation-provider",
                                                                        {
                                                                          attrs: {
                                                                            rules:
                                                                              "required"
                                                                          },
                                                                          scopedSlots: _vm._u(
                                                                            [
                                                                              {
                                                                                key:
                                                                                  "default",
                                                                                fn: function({
                                                                                  errors
                                                                                }) {
                                                                                  return [
                                                                                    _c(
                                                                                      "custom-drop-down",
                                                                                      {
                                                                                        attrs: {
                                                                                          disabled:
                                                                                            item.saved,
                                                                                          error:
                                                                                            errors[0],
                                                                                          fieldkey:
                                                                                            "id",
                                                                                          fieldname:
                                                                                            "name",
                                                                                          options:
                                                                                            _vm.filteredAbsences,
                                                                                          placeholder:
                                                                                            "Seleccione"
                                                                                        },
                                                                                        model: {
                                                                                          value:
                                                                                            item.selectedVisitInfoJustification,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              item,
                                                                                              "selectedVisitInfoJustification",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "item.selectedVisitInfoJustification"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                }
                                                                              }
                                                                            ],
                                                                            null,
                                                                            true
                                                                          )
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                              _vm.enableComment(
                                                                item.selectedType
                                                              )
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col",
                                                                      class: [
                                                                        {
                                                                          "col-md-12 mt-3":
                                                                            _vm.enableJustification(
                                                                              item.selectedType
                                                                            ) &&
                                                                            _vm.enableRepositionDate(
                                                                              item.selectedType
                                                                            )
                                                                        }
                                                                      ]
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "color-secondary-6"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " Comentario: "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "validation-provider",
                                                                        {
                                                                          attrs: {
                                                                            rules: _vm.getCommentRule(
                                                                              item
                                                                            )
                                                                          },
                                                                          scopedSlots: _vm._u(
                                                                            [
                                                                              {
                                                                                key:
                                                                                  "default",
                                                                                fn: function({
                                                                                  errors
                                                                                }) {
                                                                                  return [
                                                                                    _c(
                                                                                      "custom-text-area",
                                                                                      {
                                                                                        attrs: {
                                                                                          "custom-error-msg":
                                                                                            "",
                                                                                          disabled:
                                                                                            item.saved ||
                                                                                            !_vm.canEditReposition,
                                                                                          error:
                                                                                            errors[0],
                                                                                          "max-length": 200,
                                                                                          maxlength: 200,
                                                                                          rows: 2,
                                                                                          "single-line": true
                                                                                        },
                                                                                        model: {
                                                                                          value:
                                                                                            item.visitInfoComment,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              item,
                                                                                              "visitInfoComment",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "item.visitInfoComment"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                }
                                                                              }
                                                                            ],
                                                                            null,
                                                                            true
                                                                          )
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "b-tab",
                                                    {
                                                      attrs: {
                                                        active:
                                                          item.selectedTab ==
                                                          _vm.additionalInfoTabs
                                                            .INTERNAL_PRACTITIONER,
                                                        title:
                                                          "Practicantes / Internos"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass: "col"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col border-right"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "color-secondary-6"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Practicante / Interno: "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "custom-drop-down",
                                                                    {
                                                                      attrs: {
                                                                        disabled:
                                                                          item.saved,
                                                                        fieldkey:
                                                                          "id",
                                                                        fieldname:
                                                                          "name",
                                                                        options: _vm.internalPractitionerAvailable(
                                                                          item
                                                                        ),
                                                                        placeholder:
                                                                          "Seleccione"
                                                                      },
                                                                      on: {
                                                                        input: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.onChangePractitionerHandler(
                                                                            item,
                                                                            index
                                                                          )
                                                                        }
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          item.selectedPractitioner,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            item,
                                                                            "selectedPractitioner",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "item.selectedPractitioner"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass: "col"
                                                            },
                                                            [
                                                              _c(
                                                                "custom-chips-group",
                                                                {
                                                                  staticClass:
                                                                    "mt-n3",
                                                                  attrs: {
                                                                    disabled:
                                                                      item.saved,
                                                                    "no-background":
                                                                      "",
                                                                    "no-wrap": true,
                                                                    "object-text":
                                                                      "name",
                                                                    "selected-items":
                                                                      item.practitionerSelected,
                                                                    title:
                                                                      "Practicante / Interno seleccionados"
                                                                  },
                                                                  on: {
                                                                    itemMarkedForDeletion:
                                                                      _vm.unSelectItem
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm.enableReplaceSpecialist(
                                                    item
                                                  )
                                                    ? _c(
                                                        "b-tab",
                                                        {
                                                          attrs: {
                                                            active:
                                                              item.selectedTab ==
                                                              _vm
                                                                .additionalInfoTabs
                                                                .REPLACE_SPECIALIST,
                                                            title:
                                                              "Reemplazar Especialista / Lugar"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row mx-3"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col"
                                                                },
                                                                [
                                                                  _c(
                                                                    "checkbox",
                                                                    {
                                                                      staticClass:
                                                                        "mb-2",
                                                                      attrs: {
                                                                        text:
                                                                          "Especialista: "
                                                                      },
                                                                      on: {
                                                                        input: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.onChangeSelectedSpecialist(
                                                                            item.selectedSpecialistOption,
                                                                            index
                                                                          )
                                                                        }
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          item.selectedSpecialistOption,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            item,
                                                                            "selectedSpecialistOption",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "item.selectedSpecialistOption"
                                                                      }
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "custom-drop-down",
                                                                    {
                                                                      attrs: {
                                                                        disabled:
                                                                          (item.saved &&
                                                                            !item.isReplaceSpecialistVisible) ||
                                                                          !item.selectedSpecialistOption,
                                                                        fieldkey:
                                                                          "id",
                                                                        fieldname:
                                                                          "name",
                                                                        options:
                                                                          _vm.specialistsReplacement,
                                                                        placeholder:
                                                                          "Seleccione"
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          item.selectedSpecialist,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            item,
                                                                            "selectedSpecialist",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "item.selectedSpecialist"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    [
                                                                      _c(
                                                                        "checkbox",
                                                                        {
                                                                          staticClass:
                                                                            "mb-2",
                                                                          attrs: {
                                                                            text:
                                                                              "Tipo de Lugar: "
                                                                          },
                                                                          on: {
                                                                            input: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.onChangeSelectedPlace(
                                                                                item,
                                                                                index
                                                                              )
                                                                            }
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              item.selectedPlaceOption,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                item,
                                                                                "selectedPlaceOption",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.selectedPlaceOption"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    [
                                                                      _c(
                                                                        "custom-drop-down",
                                                                        {
                                                                          attrs: {
                                                                            disabled:
                                                                              (item.saved &&
                                                                                !item.isReplaceSpecialistVisible) ||
                                                                              !item.selectedPlaceOption,
                                                                            fieldkey:
                                                                              "id",
                                                                            fieldname:
                                                                              "name",
                                                                            options:
                                                                              _vm.visitLocations,
                                                                            placeholder:
                                                                              "Seleccione"
                                                                          },
                                                                          on: {
                                                                            input: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.onChangePlaceType(
                                                                                item,
                                                                                index
                                                                              )
                                                                            }
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              item.selectedPlaceType,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                item,
                                                                                "selectedPlaceType",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.selectedPlaceType"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm.isLocationTypeEscuela(
                                                                    item.selectedPlaceType
                                                                  )
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          item.selectedPlaceType
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "mt-3"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "color-secondary-6"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " Región: "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "custom-drop-down",
                                                                                    {
                                                                                      attrs: {
                                                                                        disabled:
                                                                                          (item.saved &&
                                                                                            !item.isReplaceSpecialistVisible) ||
                                                                                          !item.selectedPlaceOption,
                                                                                        fieldkey:
                                                                                          "id",
                                                                                        fieldname:
                                                                                          "name",
                                                                                        options:
                                                                                          _vm.visitRegions,
                                                                                        placeholder:
                                                                                          "Seleccione"
                                                                                      },
                                                                                      on: {
                                                                                        input: function(
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.onChangeRegion(
                                                                                            item,
                                                                                            index
                                                                                          )
                                                                                        }
                                                                                      },
                                                                                      model: {
                                                                                        value:
                                                                                          item.selectedRegion,
                                                                                        callback: function(
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            item,
                                                                                            "selectedRegion",
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                        expression:
                                                                                          "item.selectedRegion"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                          item.selectedPlaceType
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "mt-3"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "color-secondary-6"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " Distrito: "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "custom-drop-down",
                                                                                    {
                                                                                      attrs: {
                                                                                        disabled:
                                                                                          (item.saved &&
                                                                                            !item.isReplaceSpecialistVisible) ||
                                                                                          !item.selectedPlaceOption,
                                                                                        fieldkey:
                                                                                          "id",
                                                                                        fieldname:
                                                                                          "name",
                                                                                        options:
                                                                                          _vm.visitDistricts,
                                                                                        placeholder:
                                                                                          "Seleccione"
                                                                                      },
                                                                                      on: {
                                                                                        input: function(
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.onChangeDistrict(
                                                                                            item,
                                                                                            index
                                                                                          )
                                                                                        }
                                                                                      },
                                                                                      model: {
                                                                                        value:
                                                                                          item.selectedDistrict,
                                                                                        callback: function(
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            item,
                                                                                            "selectedDistrict",
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                        expression:
                                                                                          "item.selectedDistrict"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                          item.selectedPlaceType
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "mt-3"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "color-secondary-6"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " Escuela: "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "custom-drop-down",
                                                                                    {
                                                                                      attrs: {
                                                                                        disabled:
                                                                                          (item.saved &&
                                                                                            !item.isReplaceSpecialistVisible) ||
                                                                                          !item.selectedPlaceOption,
                                                                                        fieldkey:
                                                                                          "id",
                                                                                        fieldname:
                                                                                          "name",
                                                                                        options:
                                                                                          _vm.visitSchools,
                                                                                        placeholder:
                                                                                          "Seleccione"
                                                                                      },
                                                                                      on: {
                                                                                        input: function(
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.onChangeSchool(
                                                                                            item
                                                                                          )
                                                                                        }
                                                                                      },
                                                                                      model: {
                                                                                        value:
                                                                                          item.selectedLocationService,
                                                                                        callback: function(
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            item,
                                                                                            "selectedLocationService",
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                        expression:
                                                                                          "item.selectedLocationService"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm.isEnabledMunicipality(
                                                                    item.selectedPlaceType
                                                                  )
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "mt-3"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "color-secondary-6"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " Municipio: "
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "custom-drop-down",
                                                                            {
                                                                              attrs: {
                                                                                disabled:
                                                                                  (item.saved &&
                                                                                    !item.isReplaceSpecialistVisible) ||
                                                                                  !item.selectedPlaceOption,
                                                                                fieldkey:
                                                                                  "id",
                                                                                fieldname:
                                                                                  "name",
                                                                                options:
                                                                                  _vm.visitMunicipalities,
                                                                                placeholder:
                                                                                  "Seleccione"
                                                                              },
                                                                              on: {
                                                                                input: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onChangeMunicipality(
                                                                                    item,
                                                                                    index
                                                                                  )
                                                                                }
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  item.selectedMunicipality,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "selectedMunicipality",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item.selectedMunicipality"
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm.isEnabledLocationService(
                                                                    item.selectedPlaceType
                                                                  )
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "mt-3"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "color-secondary-6"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " Lugar de Servicio: "
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "custom-drop-down",
                                                                            {
                                                                              attrs: {
                                                                                disabled:
                                                                                  (item.saved &&
                                                                                    !item.isReplaceSpecialistVisible) ||
                                                                                  !item.selectedPlaceOption,
                                                                                fieldkey:
                                                                                  "id",
                                                                                fieldname:
                                                                                  "name",
                                                                                options:
                                                                                  _vm.visitLocationServices,
                                                                                placeholder:
                                                                                  "Seleccione"
                                                                              },
                                                                              on: {
                                                                                input: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onChangeLocationService(
                                                                                    item,
                                                                                    index
                                                                                  )
                                                                                }
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  item.selectedLocationService,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "selectedLocationService",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item.selectedLocationService"
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm.isEnabledCaat(
                                                                    item.selectedPlaceType
                                                                  )
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "mt-3"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "color-secondary-6"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " CAAT: "
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "custom-drop-down",
                                                                            {
                                                                              attrs: {
                                                                                disabled:
                                                                                  (item.saved &&
                                                                                    !item.isReplaceSpecialistVisible) ||
                                                                                  !item.selectedPlaceOption,
                                                                                fieldkey:
                                                                                  "id",
                                                                                fieldname:
                                                                                  "name",
                                                                                options:
                                                                                  _vm.visitLocationServices,
                                                                                placeholder:
                                                                                  "Seleccione"
                                                                              },
                                                                              on: {
                                                                                input: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onChangeLocationService(
                                                                                    item,
                                                                                    index
                                                                                  )
                                                                                }
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  item.selectedLocationService,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "selectedLocationService",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item.selectedLocationService"
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm.isEnabledCenter(
                                                                    item.selectedPlaceType
                                                                  )
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "mt-3"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "color-secondary-6"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " Centro: "
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "custom-drop-down",
                                                                            {
                                                                              attrs: {
                                                                                disabled:
                                                                                  (item.saved &&
                                                                                    !item.isReplaceSpecialistVisible) ||
                                                                                  !item.selectedPlaceOption,
                                                                                fieldkey:
                                                                                  "id",
                                                                                fieldname:
                                                                                  "name",
                                                                                options:
                                                                                  _vm.visitCenters,
                                                                                placeholder:
                                                                                  "Seleccione"
                                                                              },
                                                                              on: {
                                                                                input: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onChangeCenter(
                                                                                    item,
                                                                                    index
                                                                                  )
                                                                                }
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  item.selectedCenter,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "selectedCenter",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item.selectedCenter"
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.requiresDocumentation(
                                                    item
                                                  )
                                                    ? _c(
                                                        "b-tab",
                                                        {
                                                          attrs: {
                                                            active:
                                                              item.selectedTab ==
                                                              _vm
                                                                .additionalInfoTabs
                                                                .DOCUMENTS,
                                                            title: "Documentos"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row mx-4"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "color-secondary-6"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Tipo de Documento: "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "custom-drop-down",
                                                                    {
                                                                      attrs: {
                                                                        disabled:
                                                                          item.saved,
                                                                        fieldkey:
                                                                          "id",
                                                                        fieldname:
                                                                          "name",
                                                                        options:
                                                                          _vm.documentTypes,
                                                                        placeholder:
                                                                          "Seleccione"
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          item.documentType,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            item,
                                                                            "documentType",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "item.documentType"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "color-secondary-6"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Archivo "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "custom-file-input",
                                                                    {
                                                                      ref:
                                                                        "attachedDocument",
                                                                      refInFor: true,
                                                                      attrs: {
                                                                        accept:
                                                                          ".pdf",
                                                                        "attachment-id":
                                                                          item.documentId,
                                                                        disabled:
                                                                          item.saved,
                                                                        "display-style":
                                                                          "normal",
                                                                        "label-position":
                                                                          "left",
                                                                        required:
                                                                          ""
                                                                      },
                                                                      on: {
                                                                        "after-remove": function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.afterRemoveHandler(
                                                                            item,
                                                                            index
                                                                          )
                                                                        },
                                                                        input: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.onChangeDocument(
                                                                            item.selectedDocument,
                                                                            index
                                                                          )
                                                                        }
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          item.selectedDocument,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            item,
                                                                            "selectedDocument",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "item.selectedDocument"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              : null
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row align-items-center no-gutters" },
                          [
                            _c(
                              "div",
                              { staticClass: "col-12 col-md-1 col-spacing" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "color-secondary-6 font-weight-normal font-14"
                                  },
                                  [_vm._v(" Día: ")]
                                ),
                                !item.saved
                                  ? _c("validation-provider", {
                                      attrs: { name: "Día", rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-input", {
                                                  staticClass: "hour-size",
                                                  attrs: {
                                                    "custom-error-msg": "",
                                                    error: errors[0],
                                                    "mask-type": "Day",
                                                    type: "text"
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      return _vm.evalEnterDay(
                                                        item,
                                                        index
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: item.day,
                                                    callback: function($$v) {
                                                      _vm.$set(item, "day", $$v)
                                                    },
                                                    expression: "item.day"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  : _c("span", { staticClass: "color-black" }, [
                                      _vm._v(_vm._s(item.day))
                                    ])
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-12 col-md-3 col-spacing" },
                              [
                                !item.saved
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "color-secondary-6 font-weight-normal font-14"
                                      },
                                      [_vm._v(" Hora Desde: ")]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "color-secondary-6 font-weight-normal font-14"
                                      },
                                      [_vm._v(" Hora: ")]
                                    ),
                                !item.saved
                                  ? _c(
                                      "div",
                                      { staticClass: "d-flex" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "HourStartHour",
                                            rules: "required"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("custom-input", {
                                                      staticClass: "hour-size",
                                                      attrs: {
                                                        "custom-error-msg": "",
                                                        error: errors[0],
                                                        "mask-type": "Day",
                                                        type: "text"
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          return _vm.evalEnterHour(
                                                            item,
                                                            index
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          item.hourStartHour,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "hourStartHour",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.hourStartHour"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "mr-3 mt-1" },
                                          [_vm._v(":")]
                                        ),
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "HourStartMinute",
                                            rules: "required"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("custom-input", {
                                                      staticClass: "hour-size",
                                                      attrs: {
                                                        "custom-error-msg": "",
                                                        error: errors[0],
                                                        "mask-type": "Day",
                                                        type: "text"
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          return _vm.evalEnterMinute(
                                                            item,
                                                            index
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          item.hourStartMinute,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "hourStartMinute",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.hourStartMinute"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        }),
                                        _c("b-form-select", {
                                          staticClass: "ampm-size",
                                          attrs: {
                                            disabled: _vm.disableAmPm(
                                              item,
                                              index
                                            ),
                                            options: _vm.catalog.timeOptions
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.evalEnterAmPm(
                                                item,
                                                index
                                              )
                                            }
                                          },
                                          model: {
                                            value: item.hourStartTime,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item,
                                                "hourStartTime",
                                                $$v
                                              )
                                            },
                                            expression: "item.hourStartTime"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _c("div", [
                                      _c(
                                        "span",
                                        { staticClass: "color-black" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.getHourRange(item)) +
                                              " "
                                          )
                                        ]
                                      )
                                    ])
                              ]
                            ),
                            !item.saved
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-12 col-md-3 col-spacing"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "color-secondary-6 font-weight-normal font-14"
                                      },
                                      [_vm._v(" Hora Hasta: ")]
                                    ),
                                    !item.saved && !_vm.showHasta
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "font-weight-normal text-black mt-2"
                                          },
                                          [
                                            _c("label", [
                                              _vm._v(_vm._s(item.hourEnd))
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    !item.saved && _vm.showHasta
                                      ? _c(
                                          "div",
                                          { staticClass: "d-flex" },
                                          [
                                            _c("validation-provider", {
                                              attrs: {
                                                name: "hourEnd",
                                                rules: "required"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("custom-input", {
                                                          staticClass:
                                                            "hour-size",
                                                          attrs: {
                                                            "custom-error-msg":
                                                              "",
                                                            error: errors[0],
                                                            "mask-type": "Day",
                                                            type: "text"
                                                          },
                                                          model: {
                                                            value: item.hourEnd,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "hourEnd",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.hourEnd"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            }),
                                            _c(
                                              "span",
                                              { staticClass: "mr-3 mt-1" },
                                              [_vm._v(":")]
                                            ),
                                            _c("validation-provider", {
                                              attrs: {
                                                name: "hourEndMinute",
                                                rules: "required"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("custom-input", {
                                                          staticClass:
                                                            "hour-size",
                                                          attrs: {
                                                            "custom-error-msg":
                                                              "",
                                                            error: errors[0],
                                                            "mask-type": "Day",
                                                            type: "text"
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              return _vm.evalEnterAmPm(
                                                                item,
                                                                index
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              item.hourEndMinute,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "hourEndMinute",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.hourEndMinute"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            }),
                                            _c("b-form-select", {
                                              staticClass: "ampm-size",
                                              attrs: {
                                                options: _vm.catalog.timeOptions
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.evalEnterAmPm(
                                                    item,
                                                    index
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.hourEndTime,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "hourEndTime",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.hourEndTime"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "col-12 col-md-2 col-spacing" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "color-secondary-6 font-weight-normal font-14"
                                  },
                                  [_vm._v(" Tipo: ")]
                                ),
                                !item.saved
                                  ? _c(
                                      "span",
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            name: "SelectedType",
                                            rules: "required"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("CustomDropDown", {
                                                      attrs: {
                                                        disabled:
                                                          item.id ||
                                                          _vm.visitTypesOptions
                                                            .length === 0 ||
                                                          item.day ===
                                                            undefined ||
                                                          false ||
                                                          item.day === "",
                                                        error: errors[0],
                                                        fieldkey: "id",
                                                        fieldname: "name",
                                                        options:
                                                          _vm.visitTypesOptions
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          return _vm.onChangeVisitType(
                                                            item,
                                                            index
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          item.selectedType,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "selectedType",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.selectedType"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        }),
                                        item.selectedType &&
                                        item.selectedType.showPreviousYears
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "color-secondary-6 font-weight-normal font-14"
                                                  },
                                                  [_vm._v(" Año Anterior: ")]
                                                ),
                                                _c("ValidationProvider", {
                                                  attrs: { rules: "required" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function({
                                                          errors
                                                        }) {
                                                          return [
                                                            _c(
                                                              "CustomDropDown",
                                                              {
                                                                attrs: {
                                                                  error:
                                                                    errors[0],
                                                                  fieldkey:
                                                                    "id",
                                                                  fieldname:
                                                                    "name",
                                                                  options:
                                                                    _vm.previousAcademicYears
                                                                },
                                                                on: {
                                                                  input: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.onPreviousAcademicYearChanged(
                                                                      item
                                                                    )
                                                                  }
                                                                },
                                                                model: {
                                                                  value:
                                                                    item.previousAcademicYear,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      item,
                                                                      "previousAcademicYear",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "item.previousAcademicYear"
                                                                }
                                                              }
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        item.selectedType &&
                                        item.selectedType.showPreviousYears &&
                                        _vm.filteredPreviousCompensatories
                                          .length > 0 &&
                                        item.previousAcademicYear &&
                                        item.previousAcademicYear.id > 0
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "color-secondary-6 font-weight-normal font-14"
                                                  },
                                                  [_vm._v(" Solicitud: ")]
                                                ),
                                                _c("ValidationProvider", {
                                                  attrs: { rules: "required" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function({
                                                          errors
                                                        }) {
                                                          return [
                                                            _c(
                                                              "CustomDropDown",
                                                              {
                                                                attrs: {
                                                                  error:
                                                                    errors[0],
                                                                  fieldkey:
                                                                    "id",
                                                                  fieldname:
                                                                    "name",
                                                                  options:
                                                                    _vm.filteredPreviousCompensatories
                                                                },
                                                                model: {
                                                                  value:
                                                                    item.compensatoryRequestSelected,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      item,
                                                                      "compensatoryRequestSelected",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "item.compensatoryRequestSelected"
                                                                }
                                                              }
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _c("span", { staticClass: "color-black" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getItemName(item.selectedType)
                                          ) +
                                          " " +
                                          _vm._s(
                                            item.selectedType &&
                                              item.selectedType
                                                .showPreviousYears
                                              ? _vm.getItemName(
                                                  item.previousAcademicYear
                                                )
                                              : null
                                          ) +
                                          " "
                                      )
                                    ])
                              ]
                            ),
                            _vm.canEditCpt
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-12 col-md-2 col-spacing"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "color-secondary-6 font-weight-normal font-14"
                                      },
                                      [_vm._v(" CPT: ")]
                                    ),
                                    !item.saved
                                      ? _c(
                                          "span",
                                          [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                name: "cpt",
                                                rules: "required"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("CustomDropDown", {
                                                          attrs: {
                                                            disabled:
                                                              _vm
                                                                .feeScheduleCptOptions
                                                                .length <= 1,
                                                            error: errors[0],
                                                            fieldkey: "id",
                                                            fieldname: "name",
                                                            options:
                                                              _vm.feeScheduleCptOptions
                                                          },
                                                          model: {
                                                            value: item.cpt,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "cpt",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.cpt"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "color-black" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("empty")(
                                                    _vm.getItemName(item.cpt)
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                  ]
                                )
                              : _vm._e(),
                            _vm.canEditSupervisor
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-12 col-md-2 col-spacing"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "color-secondary-6 font-weight-normal font-14"
                                      },
                                      [_vm._v(" Supervisor: ")]
                                    ),
                                    !item.saved
                                      ? _c(
                                          "span",
                                          [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                name: "supervisor",
                                                rules: "required"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("CustomDropDown", {
                                                          attrs: {
                                                            disabled:
                                                              _vm
                                                                .supervisorOptions
                                                                .length <= 1,
                                                            error: errors[0],
                                                            fieldkey: "id",
                                                            fieldname: "name",
                                                            options:
                                                              _vm.supervisorOptions
                                                          },
                                                          model: {
                                                            value:
                                                              item.supervisor,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "supervisor",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.supervisor"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "color-black" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("empty")(
                                                    _vm.getItemName(
                                                      item.supervisor
                                                    )
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                  ]
                                )
                              : _vm._e(),
                            item.saved &&
                            _vm.validateSelectedVisitInfoJustification(item)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-12 col-md-2 col-spacing"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "color-secondary-6 font-weight-normal font-14"
                                      },
                                      [_vm._v(" Justificación: ")]
                                    ),
                                    _c("span", { staticClass: "color-black" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getItemName(
                                              item.selectedVisitInfoJustification
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            !_vm.isPeriodFinalized
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-md-auto col-spacing ml-auto d-flex align-items-center justify-content-end"
                                  },
                                  [
                                    _vm.enableActionMenu(item) &&
                                    !item.enableReplaceSpecialist
                                      ? _c("div", { staticClass: "dropdown" }, [
                                          !_vm.isReadOnly
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-dropdown-actions dropdown-toggle",
                                                  attrs: {
                                                    id: "dropdownMenuButton",
                                                    "aria-expanded": "false",
                                                    "aria-haspopup": "true",
                                                    "data-toggle": "dropdown",
                                                    type: "button"
                                                  }
                                                },
                                                [_vm._v(" Acciones ")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-menu dropdown-menu-right custom-dropdown-container",
                                              attrs: {
                                                "aria-labelledby":
                                                  "dropdownMenuButton"
                                              }
                                            },
                                            [
                                              _vm.canShowEditVisit(item)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item cursor-pointer mb-1",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.editVisit(
                                                            item,
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("em", {
                                                        staticClass:
                                                          "fa fa-pencil text-green pr-1"
                                                      }),
                                                      _c("span", [
                                                        _vm._v("Editar Visita")
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.canShowDeleteVisit(item)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item cursor-pointer",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.onDeleteVisit(
                                                            item.id,
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("em", {
                                                        staticClass:
                                                          "fa fa-times-circle text-red pr-1"
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          "Eliminar Visita"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c("hr", { staticClass: "mt-2" }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-item cursor-pointer mt-n2",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.replaceServicePlace(
                                                        item,
                                                        index
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("em", {
                                                    staticClass:
                                                      "fa fa-exchange text-green pr-1"
                                                  }),
                                                  _c("span", [
                                                    _vm._v(
                                                      "Reemplazar Lugar de Servicio y/o Especialista"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm.enableActionButton(item)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center"
                                          },
                                          [
                                            (!item.saved && item.id) ||
                                            item.enableReplaceSpecialist
                                              ? _c(
                                                  "action-button",
                                                  {
                                                    staticClass: "px-4 mr-2",
                                                    attrs: {
                                                      i: "fas fa-times-circle",
                                                      variant:
                                                        "outline-danger btn-cancel danger"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.onCancelEdit(
                                                          item,
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(" Cancelar ")]
                                                )
                                              : _vm._e(),
                                            _c("action-button", {
                                              staticClass: "px-4",
                                              attrs: {
                                                i: "fas fa-plus",
                                                text: "Guardar",
                                                variant: "success"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleSaveVisit(
                                                    item,
                                                    item.id,
                                                    index
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            item.hasOverrideLocationType ||
                            item.hasOverrideSpecialist
                              ? _c(
                                  "div",
                                  { staticClass: "col-md-12 mt-n2" },
                                  [
                                    item.hasOverrideLocationType
                                      ? _c("visit-tag", {
                                          attrs: {
                                            color: "orange",
                                            icon: "fas fa-map-marker-edit",
                                            label:
                                              "Reemplazo de Lugar de Servicio",
                                            type: "red"
                                          }
                                        })
                                      : _vm._e(),
                                    item.hasOverrideSpecialist
                                      ? _c("visit-tag", {
                                          attrs: {
                                            color: "green",
                                            icon: "fas fa-user-md",
                                            label: "Reemplazo de Especialista",
                                            type: "green"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                (item.errors || item.validations) && !_vm.isPeriodFinalized
                  ? _c(
                      "div",
                      { staticClass: "visit-error-container" },
                      [
                        _vm._l(item.validations, function(error, errorIndex) {
                          return _c("error", {
                            key: `validation-container-visit` + errorIndex,
                            attrs: { message: error, variant: "no-border" }
                          })
                        }),
                        _vm._l(item.errors, function(error, errorIndex) {
                          return _c("error", {
                            key: `error-container-visit` + errorIndex,
                            attrs: { message: error, variant: "no-border" }
                          })
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }